import React, { useEffect, useMemo, useState } from 'react'
import 'react-toastify/dist/ReactToastify.min.css'
import { resyncClientMonitorThunk, startClientMonitorThunk } from '../../redux/thunk/clientMonitorConfig'
import { setClientMonitorConfigForbidden } from '../../redux/action/clientMonitorConfig'
import { isClientMonitor, isNativeAppMode } from '../../helper/clientMonitor'
import { selectIsAuthorized } from '../../redux/selector/system'
import { useDispatch, useSelector } from 'react-redux'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { isCashRegisterMode } from '../../helper/mode'
import { getClientMonitorCartStateThunk, updateClientMonitorCartThunk } from '../../redux/thunk/clientMonitorCart'
import { localStorageApi } from '../../helper/localStorageApi'

const ClientMonitorWindow = React.memo(() => {
	const isAuthorized = useSelector(selectIsAuthorized)
	const dispatch = useDispatch()
	const [desktopMode] = useLocalStorage('desktopMode', null)
	const clientMonitorIsActive = useSelector(state => state.clientMonitorConfig.config?.enabled)
	const [desktopDeviceId, setDesktopDeviceId] = useState(null)

	const cashRegisterMode = useMemo(() => isCashRegisterMode(desktopMode), [desktopMode])
	const isClientMonitr = useMemo(() => isClientMonitor(), [])

	useEffect(() => {
		const deviceId = localStorageApi.getItem('desktopDeviceId')
		setDesktopDeviceId(deviceId)
	}, [])

	useEffect(() => {
		if (!isNativeAppMode() || isClientMonitr) return
		dispatch(setClientMonitorConfigForbidden(false))
		dispatch(resyncClientMonitorThunk())
		const intervalId = setInterval(() => dispatch(resyncClientMonitorThunk()), 5000)
		return () => clearInterval(intervalId)
	}, [isAuthorized, clientMonitorIsActive]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (isNativeAppMode() || isClientMonitr) return
		if (isAuthorized && cashRegisterMode) {
			dispatch(startClientMonitorThunk())
		}
	}, [isAuthorized, isClientMonitr, cashRegisterMode, clientMonitorIsActive]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (isNativeAppMode() || isClientMonitr) return
		const fetchAndUpdateCartState = async () => {
			if (isAuthorized && clientMonitorIsActive) {
				const data = await dispatch(getClientMonitorCartStateThunk(desktopDeviceId))

				if (data?.purchaseItems?.length) {
					dispatch(updateClientMonitorCartThunk('CASH_DESK', () => {}))
					dispatch(updateClientMonitorCartThunk('DELIVERY', () => {}))
				}
			}
		}

		fetchAndUpdateCartState()
	}, [isAuthorized, clientMonitorIsActive]) // eslint-disable-line react-hooks/exhaustive-deps

	return null
})

ClientMonitorWindow.displayName = 'ClientMonitorWindow'
export default ClientMonitorWindow
